import React from 'react';
import ProductItemView from '../ProductItemView';
import dashboard from '../../resource/middleware/dashboard.svg';


const Dashboard = () => {
    return (
        <ProductItemView
            title="Tablero de Control Web"
            items={["Administración simple desde un sitio web", "Dashboard de conexiones en tiempo real", "Monitor de comunicaciones en tiempo real"]}
            image={dashboard}
            centered />
    );
};

export default Dashboard;